import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from './actions';
import { Store } from '@ngrx/store';
import { AlarmService, GetAlarmListRequest, VehicleService } from '@services/api/api.service';
import { promiseWrapper } from '@shared/_funtions/promiseWarapper.function';
import { selectAlarms, selectSelectedAlarm } from '@redux/modules/alarms/index';
import { selectUser } from '@redux/index';

@Injectable()
export class ActiveAlarmEffects {
  private language = 'en';

  setAlarmsFilters$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.setAlarmsFilters),
    tap(() => {
      this.store.dispatch(fromActions.setAlarmsPaginator({ paginator: { page: 1, pageSize: 10 } }));
    }),
  ), { dispatch: false });

  setSelectedAlarmFilters$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.setSelectedAlarmFilters),
    tap(() => {
      this.store.dispatch(fromActions.setSelectedAlarmPaginator({ paginator: { page: 1, pageSize: 10 } }));
    }),
  ), { dispatch: false });

  public $getAlarmsCounters = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAlarmsCounters),
    tap(() => this.store.dispatch(fromActions.setAlarmsLoading({ isLoading: true }))),
    switchMap(async () => {
      const counters = await promiseWrapper(this.alarmService.getAlarmsCounters());
      return [fromActions.setAlarmsCounters({
        counters,
      })];
    }),
    switchMap((actions) => [...actions]),
  ));

  getAlarmsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getAlarmsList,
        fromActions.setAlarmsPaginator),
      withLatestFrom(
        this.store.select(selectAlarms),
      ),
      tap(() => this.store.dispatch(fromActions.setAlarmsLoading({ isLoading: true }))),
      switchMap(async ([action, alarms]) => {
        const hasFilterModel = alarms.filters.filterModel?.concatenatedFmi ||
          alarms.filters.filterModel?.concatenatedEcuAddress ||
          alarms.filters.filterModel?.concatenatedSpn || alarms.filters.filterModel?.highAlarmCounter ||
          alarms.filters.filterModel?.mediumAlarmCounter ||
          alarms.filters.filterModel?.lowAlarmCounter;

        const request: GetAlarmListRequest = {
          page: alarms.paginator.page,
          pageSize: alarms.paginator.pageSize,
          ...(alarms.filters.qSearch ? { qSearch: alarms.filters.qSearch } : {}),
          ...(hasFilterModel ? {
            filterModel: {
              ...alarms.filters.filterModel,
              ...(alarms.filters.filterModel?.concatenatedFmi
                ? { concatenatedFmi: alarms.filters.filterModel.concatenatedFmi }
                : {}),
              ...(alarms.filters.filterModel?.concatenatedEcuAddress
                ? { concatenatedEcuAddress: alarms.filters.filterModel.concatenatedEcuAddress }
                : {}),
              ...(alarms.filters.filterModel?.concatenatedSpn
                ? { concatenatedSpn: alarms.filters.filterModel.concatenatedSpn }
                : {}),
            },
          } : {}),
          ...(alarms.filters.sortModel ? { sortModel: alarms.filters.sortModel } : {}),
        };
        const vehiclesData = await promiseWrapper(this.alarmService.getAlarmsList(request,
        ));
        return [
          fromActions.setAlarmsList({ response: vehiclesData }),
          fromActions.setAlarmsLoading({ isLoading: false }),
        ];
      }),
      switchMap((actions) => [...actions]),
    ),
  );

  getSelectedAlarmList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getSelectedAlarmList,
        fromActions.setSelectedAlarmPaginator),
      withLatestFrom(
        this.store.select(selectSelectedAlarm),
      ),
      tap(() => this.store.dispatch(fromActions.setSelectedAlarmLoading({ isLoading: true }))),
      switchMap(async ([action, selectedAlarm]) => {
        // const request: GetAlarmListRequest = {
        //   page: selectedAlarm.paginator.page,
        //   pageSize: selectedAlarm.paginator.pageSize,
        //   ...(selectedAlarm.filters.qSearch ? { qSearch: selectedAlarm.filters.qSearch } : {}),
        //   ...(selectedAlarm.filters.filterModel ? { filterModel: selectedAlarm.filters.filterModel } : {}),
        //   ...(selectedAlarm.filters.sortModel ? { sortModel: selectedAlarm.filters.sortModel } : {})
        // }
        const vehiclesData = await promiseWrapper(this.vehicleService.getVehicleAlarmsByVin(selectedAlarm.vin, this.language,
        ));
        return [
          fromActions.setSelectedAlarmList({ response: vehiclesData }),
          fromActions.setSelectedAlarmLoading({ isLoading: false }),
        ];
      }),
      switchMap((actions) => [...actions]),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private alarmService: AlarmService,
    private vehicleService: VehicleService,
  ) {
    this.store.select(selectUser).subscribe(user => {
      if (!user?.user_metadata) {
        return;
      }
      this.language = user?.user_metadata?.language || 'en';
    });
  }
}
